// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeTokenApi = class EdgeTokenApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param ICreateSessionRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationGuest(ICreateSessionRequest, x_program_id) {
        const _url_ = '/edge/token/v1/Authentication/guest';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ICreateSessionRequest' is not null or undefined
        if (ICreateSessionRequest === null || ICreateSessionRequest === undefined) {
            throw new Error('Required parameter ICreateSessionRequest was null or undefined when calling authenticationGuest.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ICreateSessionRequest, "ICreateSessionRequest"),
        };
        await Promise.all([
            this.authentications['UserId'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IAuthenticationResponseModel");
        }
        return response;
    }
    /**
     *
     * @param IExistingUserRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationIsExistingUser(IExistingUserRequest, x_program_id) {
        const _url_ = '/edge/token/v1/Authentication/isExistingUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IExistingUserRequest' is not null or undefined
        if (IExistingUserRequest === null || IExistingUserRequest === undefined) {
            throw new Error('Required parameter IExistingUserRequest was null or undefined when calling authenticationIsExistingUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IExistingUserRequest, "IExistingUserRequest"),
        };
        await Promise.all([
            this.authentications['UserId'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationIsExistingUserResponse");
        }
        return response;
    }
    /**
     *
     * @param IAuthenticateAndCreateSessionRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationLogin(IAuthenticateAndCreateSessionRequest, x_program_id) {
        const _url_ = '/edge/token/v1/Authentication/login';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IAuthenticateAndCreateSessionRequest' is not null or undefined
        if (IAuthenticateAndCreateSessionRequest === null || IAuthenticateAndCreateSessionRequest === undefined) {
            throw new Error('Required parameter IAuthenticateAndCreateSessionRequest was null or undefined when calling authenticationLogin.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IAuthenticateAndCreateSessionRequest, "IAuthenticateAndCreateSessionRequest"),
        };
        await Promise.all([
            this.authentications['UserId'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IAuthenticationResponseModel");
        }
        return response;
    }
    /**
     *
     * @param ITouchSessionRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async authenticationTouch(ITouchSessionRequest, x_program_id) {
        const _url_ = '/edge/token/v1/Authentication/touch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ITouchSessionRequest' is not null or undefined
        if (ITouchSessionRequest === null || ITouchSessionRequest === undefined) {
            throw new Error('Required parameter ITouchSessionRequest was null or undefined when calling authenticationTouch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ITouchSessionRequest, "ITouchSessionRequest"),
        };
        await Promise.all([
            this.authentications['UserId'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationTouchResponse");
        }
        return response;
    }
};
EdgeTokenApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeTokenApi);
export { EdgeTokenApi };
//# sourceMappingURL=edgeTokenApi.js.map